import { createClient } from "@supabase/supabase-js";

// Configurações de produção
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 
  (typeof window !== 'undefined' && (window as any).env?.VITE_SUPABASE_URL) ||
  'https://gvaxnecmbboynlbolmpk.supabase.co';

const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 
  (typeof window !== 'undefined' && (window as any).env?.VITE_SUPABASE_ANON_KEY) ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd2YXhuZWNtYmJveW5sYm9sbXBrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk0NTIyOTIsImV4cCI6MjA3NTAyODI5Mn0.ew_Br4poyMEkXgfzTSteG6nODyI1XX4ULTetmyI1LWE';

export const supabase = createClient(supabaseUrl, supabaseKey);
